import add from 'date-fns/add';
import type { Duration } from 'date-fns';

import userLocalStorage from './userLocalStorage';

export interface SetOptions {
  duration?: Duration;
}

const STORAGE_PREFIX = 'has-seen-';
const DEFAULT_DURATION: Duration = { years: 100 };

function getKey(nameOfWhatToSee: string) {
  return `${STORAGE_PREFIX}${nameOfWhatToSee}`;
}

export default function getUserHasSeen(userId: string | number) {
  return {
    async get(name: string) {
      const endDateStr = await userLocalStorage.getItem(getKey(name), String(userId));

      if (!endDateStr) {
        return false;
      }

      // handle legacy values
      if (typeof endDateStr === 'boolean') {
        return endDateStr;
      }

      const endDate = new Date(endDateStr);

      return new Date() <= endDate;
    },

    set(name: string, { duration = DEFAULT_DURATION }: SetOptions = {}) {
      const endDate = add(new Date(), duration);

      return userLocalStorage.setItem(getKey(name), userId, endDate);
    },
  };
}
